// إعداد القائمة الجانبية لبوابة «تسيار للملاعب» — مستقلة عن قائمة المنشأة الكاملة
export const venueOwnerNavigation = [
  {
    group: 'تسيار للملاعب',
    key: 'main',
    items: [
      { name: 'الرئيسية', href: '/venue-owner-dashboard', icon: 'home' },
      { name: 'الحجوزات', href: '/venue-owner-dashboard/bookings', icon: 'inbox' },
      { name: 'التقويم', href: '/venue-owner-dashboard/calendar', icon: 'calendar' },
      { name: 'الملاعب والكورتات', href: '/venue-owner-dashboard/venues', icon: 'field' },
      { name: 'العملاء', href: '/venue-owner-dashboard/customers', icon: 'users' },
      { name: 'التقارير', href: '/venue-owner-dashboard/reports', icon: 'chart' },
      { name: 'الإشعارات/واتساب', href: '/venue-owner-dashboard/notifications', icon: 'whatsapp' },
      { name: 'صفحة الملعب العامة', href: '/venue-owner-dashboard/public-page', icon: 'share' },
      { name: 'الاشتراك', href: '/venue-owner-dashboard/subscription', icon: 'wallet' },
      { name: 'الإعدادات', href: '/venue-owner-dashboard/settings', icon: 'cog' },
    ],
  },
];

export const VENUE_OWNER_ROUTE_TITLES = {
  '/venue-owner-dashboard': 'الرئيسية',
  '/venue-owner-dashboard/bookings': 'الحجوزات',
  '/venue-owner-dashboard/calendar': 'التقويم',
  '/venue-owner-dashboard/venues': 'الملاعب والكورتات',
  '/venue-owner-dashboard/customers': 'العملاء',
  '/venue-owner-dashboard/reports': 'التقارير',
  '/venue-owner-dashboard/notifications': 'الإشعارات/واتساب',
  '/venue-owner-dashboard/public-page': 'صفحة الملعب العامة',
  '/venue-owner-dashboard/subscription': 'الاشتراك',
  '/venue-owner-dashboard/settings': 'الإعدادات',
};

export const getVenueOwnerRouteTitle = (pathname) => VENUE_OWNER_ROUTE_TITLES[pathname] || 'تسيار للملاعب';
